import { Translate } from 'react-redux-i18n'
import { Element } from '../html/element'
import PropTypes from 'prop-types'

export const Label = ({ isActive, label, isI18n, style }) => {
  return (
    <Element
      elementName="span"
      style={{
        ...style,
        color: isActive ? '#0553A5' : '#191D25',
        fontWeight: isActive ? 600 : 400,
      }}
    >
      {isI18n ? <Translate value={label} /> : label}
    </Element>
  )
}

Label.propTypes = {
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  isI18n: PropTypes.bool,
  style: PropTypes.object,
}

Label.defaultProps = {
  isActive: false,
  isI18n: true,
  style: {},
}
